// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__cxCmq","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__TY-as"};